/**
 * TanStack Query hooks for `advertiser-invoices`. Thin wrappers over ./api.
 */
import { useMutation, useQuery, type UseMutationResult, type UseQueryResult } from "@tanstack/react-query";
import {
	advertiserInvoicesQueryKeys,
	getPdfUrl,
	list,
	type InvoicePdfResponse,
	type ListAdvertiserInvoicesResponse,
	type ListParams,
} from "./api";

export function useAdvertiserInvoicesList(
	params: ListParams,
	opts?: { enabled?: boolean },
): UseQueryResult<ListAdvertiserInvoicesResponse, Error> {
	return useQuery({
		queryKey: advertiserInvoicesQueryKeys.list(params.advertiserId, params.year),
		queryFn: () => list(params),
		enabled: (opts?.enabled ?? true) && params.advertiserId.length > 0,
	});
}

export function useInvoicePdf(): UseMutationResult<InvoicePdfResponse, Error, string> {
	return useMutation({
		mutationFn: (id: string) => getPdfUrl(id),
	});
}
